// Purchase Management Routes

import { app_modules, action_options } from "helpers/apps_modules_list";
import PurchaseManagementProductListing from "pages/Procurement/PurchaseRequest/List/PurchaseRequest";
import PurchaseManagementServicePage from "pages/Procurement/PurchaseOrder/List";
import PurchaseRequestForm from "pages/Procurement/PurchaseRequest/Form/Create/PurchaseRequestForm";
import PurchaseRequestViewDetails from "pages/Procurement/PurchaseRequest/ViewDetails/ViewDetails";
import PurchaseRequestEdit from "pages/Procurement/PurchaseRequest/Form/Edit/PurchaseRequestEdit";
import PurchaseRequestApproveForm from "pages/Procurement/PurchaseRequest/Form/Approve/PurchaseRequestApproveForm";
import ApprovedPRViewDetails from "pages/Procurement/PurchaseOrder/View/ApprovedPRViewDetails";
import PurchaseOrderDetails from "pages/Procurement/PurchaseOrder/View/PurchaseOrderDetails";
import CreatePurchaseOrder from "pages/Procurement/PurchaseOrder/Form/Create/CreatePurchaseOrder";
import CreatePurchaseOrderDirect from "pages/Procurement/PurchaseOrder/Form/CreateDirectPO/CreatePurchaseOrderDirect";
import EditPurchaseOrder from "pages/Procurement/PurchaseOrder/Form/Edit/EditPurchaseOrder";
const PurchaseManagementRoutes: any = [
    {
        path: "/purchase-management/purchase-request",
        name: "Purchase Request",
        component: <PurchaseManagementProductListing />,
        permissions: {
            app_name: app_modules?.purchase_management?.app_name,
            module_name: app_modules?.purchase_management?.modules?.purchase_request,
            action: action_options?.view,
        },
    },
    {
        path: "/purchase-management/purchase-order",
        name: "Purchase Order",
        component: <PurchaseManagementServicePage />,
        permissions: {
            app_name: app_modules?.purchase_management?.app_name,
            module_name: app_modules?.purchase_management?.modules?.purchase_order,
            action: action_options?.view,
        },
    },
    // Purchase Request Routes
    {
        path: "/purchase-management/create-purchase-request",
        name: "Create Purchase Request",
        component: <PurchaseRequestForm />,
        permissions: {
            app_name: app_modules?.purchase_management?.app_name,
            module_name: app_modules?.purchase_management?.modules?.purchase_request,
            action: action_options?.create,
        },
    },
    {
        path: "/purchase-request-view-details/:pr_id",
        name: "Purchase Request View Details",
        component: <PurchaseRequestViewDetails />,
        permissions: {
            app_name: app_modules?.purchase_management?.app_name,
            module_name: app_modules?.purchase_management?.modules?.purchase_request,
            action: action_options?.view,
        },
    },
    {
        path: "/edit-purchase-request/:pr_id",
        name: "Edit Purchase Request",
        component: <PurchaseRequestEdit />,
        permissions: {
            app_name: app_modules?.purchase_management?.app_name,
            module_name: app_modules?.purchase_management?.modules?.purchase_request,
            action: action_options?.update,
        },
    },
    {
        path: "/approve-purchase-request-form/:id",
        name: "Approve Purchase Request",
        component: <PurchaseRequestApproveForm />,
        permissions: {
            app_name: app_modules?.purchase_management?.app_name,
            module_name: app_modules?.purchase_management?.modules?.purchase_request,
            action: action_options?.update,
        },
    },
    // Purchase Order Routes
    {
        path: "/purchase-request-approved-pr-view-details/:pr_id",
        name: "Approved PR View Details",
        component: <ApprovedPRViewDetails />,
        permissions: {
            app_name: app_modules?.purchase_management?.app_name,
            module_name: app_modules?.purchase_management?.modules?.purchase_order,
            action: action_options?.view,
        },
    },
    {
        path: "/purchase-order-view-details/:po_id",
        name: "Purchase Order View Details",
        component: <PurchaseOrderDetails />,
        permissions: {
            app_name: app_modules?.purchase_management?.app_name,
            module_name: app_modules?.purchase_management?.modules?.purchase_order,
            action: action_options?.view,
        },
    },
    {
        path: "/purchase-request-approved-create-purchase-order/:pr_id",
        name: "Create Purchase Order from Approved PR",
        component: <CreatePurchaseOrder />,
        permissions: {
            app_name: app_modules?.purchase_management?.app_name,
            module_name: app_modules?.purchase_management?.modules?.purchase_order,
            action: action_options?.create,
        },
    },
    {
        path: "/create-direct-purchase-order",
        name: "Create Direct Purchase Order",
        component: <CreatePurchaseOrderDirect />,
        permissions: {
            app_name: app_modules?.purchase_management?.app_name,
            module_name: app_modules?.purchase_management?.modules?.purchase_order,
            action: action_options?.create,
        },
    },

    {
        path: "/create-purchase-order/:pr_id",
        name: "Create Purchase Order from Approved PR",
        component: <CreatePurchaseOrder />,
        permissions: {
            app_name: app_modules?.purchase_management?.app_name,
            module_name: app_modules?.purchase_management?.modules?.purchase_order,
            action: action_options?.create,
        },
    },
    {
        path: "/edit-purchase-order/:po_id",
        name: "Edit Purchase Order",
        component: <EditPurchaseOrder />,
        permissions: {
            app_name: app_modules?.purchase_management?.app_name,
            module_name: app_modules?.purchase_management?.modules?.purchase_order,
            action: action_options?.update,
        },
    }
];

export default PurchaseManagementRoutes;
